export enum IdType {
  IC = '001',
  BirthCertificate = '002',
  ArmyIC = '003',
  PoliceIC = '004',
  Passport = '005',
  BusinessRegistration = '006',
  CertificateOfIncorporation = '007',
  CertificateOfRegistration = '008',
  MyPR = '009',
  Others = '099',
}
